// extracted by mini-css-extract-plugin
export default {"modalHeader":"oXcnJB","notIframe":"_6sftGL"};